<template>
  <div class="my-attended-lectures-template" theme>
    <div id="theme-my-attended-lectures-header" />
    <div id="theme-my-attended-lectures-leftside" />
    <div id="theme-my-attended-lectures-content" />
    <div id="theme-my-attended-lectures-rightside" />
    <div id="theme-my-attended-lectures-footer" />
    <b-modal
      id="delete-atnlc-confirm-modal"
      ref="deleteAtnlcConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteAtnlc()"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'my-attended-lectures',
      parts: [
        {
          elem: '#theme-my-attended-lectures-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-my-attended-lectures-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-my-attended-lectures-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-my-attended-lectures-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-my-attended-lectures-footer',
          htmlFile: 'footer'
        }
      ]
    }
  },
  mounted() {
    this.$eventHub.$on('delete-atnlc-confirm', this.onDeleteAtnlcConfirm)
  },
  beforeDestroy() {
    this.$eventHub.$off('delete-atnlc-confirm', this.onDeleteAtnlcConfirm)
  },
  methods: {
    onDeleteAtnlcConfirm(params) {
      if (this.componentId === params.componentId) {
        this.deleteAtnlcTarget = params.atnlc
        this.deleteAtnlcTargetGroupId = params.groupId
        this.showModal('deleteAtnlcConfirmModalRef')
      }
    },
    deleteAtnlc() {
      this.$axios
        .$delete('atnlc/deleteAtnlc?id=' + this.deleteAtnlcTarget.id)
        .then(response => {
          if (response.resultCode === 'success') {
            $('[atnlc-id=' + this.deleteAtnlcTarget.id + ']').remove()
            if (
              this.pageInfos &&
              this.pageInfos[this.deleteAtnlcTargetGroupId]
            ) {
              if (this.pageInfos[this.deleteAtnlcTargetGroupId].totalSize) {
                this.pageInfos[this.deleteAtnlcTargetGroupId].totalSize--
              }
              if (this.pageInfos[this.deleteAtnlcTargetGroupId].loadedSize) {
                this.pageInfos[this.deleteAtnlcTargetGroupId].loadedSize--
              }
              this.$eventHub.$emit(
                'items-loaded',
                this.pageInfos[this.deleteAtnlcTargetGroupId]
              )
            }
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    }
  }
}
</script>

<style scoped>
.my-attended-lectures-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
